import axios from './axios';
import { LoginForm, RegisterForm, PhoneLoginForm, AuthResponse, AuthUserRegResponse, AuthUserResponse, FeedbackParam } from '../types/user';

export const login = async (data: LoginForm): Promise<AuthResponse> => {
  const response = await axios.post('/api2/app/account/emailLogin', data);
  return response.data.data;
};

export const register = async (data: RegisterForm): Promise<AuthUserRegResponse> => {
  const response = await axios.post('/api2/app/account/emailRegister', data);
  return response.data;
};

export const logout = async (): Promise<void> => {
  const response = await axios.post('/api2/app/account/logout');
  localStorage.removeItem('token');
  return response.data.data;
};

export const getCurrentUser = async (): Promise<AuthUserResponse> => {
  const response = await axios.get('/api2/app/user/v2/getUserInfo');
  return response.data.data;
}; 

export const feedback = async (data: FeedbackParam): Promise<AuthUserResponse> => {
  const response = await axios.post('/api2/app/feedback/submit', data);
  return response.data.data;
}; 

export const forgotPassword = async (data: { email: string, code: string, password: string }): Promise<{code: number, message: string}> => {
  const response = await axios.post('/api2/app/account/forgotPassword', data);
  return response.data;
}; 

export const sendEmailCode = async (data: {email: string}): Promise<AuthUserResponse> => {
  const response = await axios.post('/api2/app/account/sendEmailCode', data);
  return response.data.data;
};

export const sendPhoneCode = async (data: {phone: string}): Promise<any> => {
  const response = await axios.post('/api2/app/account/sendPhoneCode', data, {
    headers: {
      'osType': 'h5'
    }
  });
  return response.data;
};

export const phoneLogin = async (data: PhoneLoginForm): Promise<AuthResponse> => {
  const response = await axios.post('/api2/app/account/phoneLogin', data, {
    headers: {
      'osType': 'h5'
    }
  });
  return response.data.data;
}; 
